const NON_DIGITS_AND_LETTERS = /[^A-Za-z0-9\s]+/;

export function hasDigitsAndLettersOnly(value: string): boolean {
  return !NON_DIGITS_AND_LETTERS.test(value);
}
